/**
 * Reads the AIChatShell context. Throws if used outside its provider.
 *
 * Isolated read path for the Shell slice (isChatbotOpen, chatbotWidth, isDevMode + setters).
 * Consumers that only dispatch should use useAIChatShellActions() instead, so they subscribe to
 * the stable action object and skip state re-renders.
 */
import { useContext } from 'react';
import { AIChatShellContext } from './AIChatShellProvider';
import type { AIChatShellValue } from './AIChatShellProvider';

export function useAIChatShell(): AIChatShellValue {
  const context = useContext(AIChatShellContext);
  if (!context) {
    throw new Error('useAIChatShell must be used within a AIChatShellProvider');
  }
  return context;
}
